import { render } from "./WGroupedSelector.vue?vue&type=template&id=90d68876&scoped=true"
import script from "./WGroupedSelector.vue?vue&type=script&lang=js"
export * from "./WGroupedSelector.vue?vue&type=script&lang=js"

import "./WGroupedSelector.vue?vue&type=style&index=0&id=90d68876&scoped=true&lang=css"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d68876"]])

export default __exports__